import { Col } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { db } from "../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import { FaEye } from "react-icons/fa";
import spinner from '../assets/img/spinner.svg'; // Adjust the path to your spinner image

export const ProjectCard = ({ category }) => {
  const [myProjects, setMyProjects] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchProjects() {
      try {
        setLoading(true); // Set loading to true when fetching starts
        const projectsRef = collection(db, "projects");
        const q = query(projectsRef, where("projectCategory", "==", category));
        const querySnap = await getDocs(q);
        let Projects = [];
        querySnap.forEach((doc) => {
          Projects.push({
            id: doc.id,
            data: doc.data(),
          });
        });
        setMyProjects(Projects);
        setLoading(false); // Set loading to false after data is fetched
      } catch (error) {
        console.log(error);
        setLoading(false); // Set loading to false on error
      }
    }
    fetchProjects();
  }, [category]); // Run useEffect when category changes

  const handleCardClick = (id) => {
    navigate(`/product-details/${id}`);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 576);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {loading ? ( // Render spinner while loading
        <div className="spinner-container">
          <img src={spinner} alt="Loading..." className="spinner" />
        </div>
      ) : (
        // Render project cards once data is loaded
        myProjects.map((project) => (
          <Col key={project.id} onClick={() => handleCardClick(project.id)} style={{ cursor: 'pointer' }} className="project-one-card">
            {isMobile ? (
              <div className="proj-imgbx" style={{ height: "250px",border:"3px solid purple" }}>
                <img src={project.data.projectImage} alt="Project" style={{ width: "100%", height: "80%", objectFit: "contain", borderRadius: "30px", marginBottom: "10px", border: "2px solid white" }} />
                <h4 style={{ fontWeight: "700", fontSize: "17px" }}>{project.data.projectName}</h4>
              </div>
            ) : (
              <div className="proj-imgbx" style={{ height: "200px",border:"3px solid purple" }}>
                <img src={project.data.projectImage} alt="Project" style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: "30px" }} />
                <div className="proj-txtx">
                  <h4 style={{ fontWeight: "800" }}>{project.data.projectName}</h4>
                  <FaEye style={{ fontSize: "40px", color: "white", fontWeight: "800" }} />
                </div>
              </div>
            )}
          </Col>
        ))
      )}
    </>
  );
};
